import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import wtyReportApi from "../../services/warrantyReportAxios";

const initialState = {
  expirationSearchQueryObj: {},
  expirationReportList: [],
  pageData: {
    pageNumber: 1,
    pageSize: 200,
    count: 200,
    hasMore: false,
    totalRecords: 0,
  },
  loading: false,
  error: null,
};

export const getExpirationReport = createAsyncThunk(
  "expirationReportSearch/getExpirationReport",
  async ({ expirationReportQueryObj, pageSize, pageNumber }) => {
    const expirationReportUrl =
      "/machine-search/expiration-report" +
      "?pageNumber=" +
      pageNumber +
      "&pageSize=" +
      pageSize;
    /*const params = {
            pageSize: pageSize,
            pageNumber: pageNumber
        }
        console.log("params:", params);*/
    try {
      const response = await wtyReportApi.post(
        expirationReportUrl,
        expirationReportQueryObj
      );
      if (response.status !== 200) {
        new Error("Calling api to get Expiration report failed.");
      }
      return await response.data;
    } catch (error) {
      throw error;
    }
  }
);

const expirationReportSlice = createSlice({
  name: "expirationReport",
  initialState,
  reducers: {
    setExpirationSearchQueryObject: (state, action) => {
      state.expirationSearchQueryObj = action.payload;
    },
    setExpirationToDefault: (state) => {
      state.expirationSearchQueryObj = {};
      state.expirationReportList = [];
      state.pageData = {
        pageNumber: 1,
        pageSize: 200,
        count: 200,
        hasMore: false,
      };
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getExpirationReport.pending, (state) => {
        state.loading = true;
        state.expirationReportList = [];
        state.error = undefined;
        state.pageData.totalRecords = 0;
      })
      .addCase(getExpirationReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error;
        state.pageData.totalRecords = 0;
      })
      .addCase(getExpirationReport.fulfilled, (state, action) => {
        state.loading = false;
        state.expirationReportList = action.payload?.machines;
        state.pageData.pageNumber = action.payload?.pageNumber;
        state.pageData.count = action.payload?.count;
        state.pageData.hasMore = action.payload?.hasMore;
        state.pageData.totalRecords = action.payload?.totalRecords;
        state.pageData.pageSize = action.payload?.pageSize;
        state.error = undefined;
      });
  },
});

export const { setExpirationSearchQueryObject, setExpirationToDefault } =
  expirationReportSlice.actions;

export const expirationReportList = (state) =>
  state.expirationReportResponse.expirationReportList;
export const expirationReportError = (state) =>
  state.expirationReportResponse.error;
export const expSearchQueryObject = (state) =>
  state.expirationReportResponse.expirationSearchQueryObj;
export const expirationReportLoading = (state) =>
  state.expirationReportResponse.loading;

export const expirationReportPageSize = (state) =>
  state.expirationReportResponse.pageData.pageSize;

export const expirationReportRecordCount = (state) =>
  state.expirationReportResponse.pageData.count;
export const expirationReportPageNumber = (state) =>
  state.expirationReportResponse.pageData.pageNumber;
export const expirationTotalRecords = (state) =>
  state.expirationReportResponse.pageData.totalRecords;
export const expirationReportPageHasMoreRecords = (state) =>
  state.expirationReportResponse.pageData.hasMore;

export default expirationReportSlice.reducer;
